export default "__VITE_ASSET__CweiTO6Y__"